const copyTextBtn = document.querySelectorAll(".copy-text-btn");
const copyTooltip = document.querySelectorAll(".copy-tooltip");

copyTextBtn.forEach((copyBtn) => {
  copyBtn.addEventListener("click", function () {
    let copyText = document.querySelectorAll(".copy-text");

    copyText[0].select();

    copyText[0].setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText[0].value);
    copyTooltip.forEach(function (item) {
      item.style.opacity = "1";
    });
    setTimeout( function() {
      copyTooltip.forEach(function (item) {
        item.style.opacity = "0";
      });
    }, 1500);
  });

  copyBtn.addEventListener("keypress", function(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      copyBtn.click();
    }
  });
});
